var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("multiselect", {
    attrs: {
      options: _vm.options,
      searchable: false,
      "close-on-select": _vm.closeOnSelect,
      "show-labels": false,
      placeholder: _vm.placeholder,
      multiple: _vm.multiple,
      limit: _vm.limit,
      "limit-text": _vm.limitText,
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }